import React from 'react';
import classNames from 'classnames';

import styles from './popover-content.scss';

export const PopoverContentSeparator = () => <div className={classNames(styles.separator, 'ma-popover-border')} />;
